import { apiSlice } from '@/app/globalRedux/api/apiSlice'

// Post news for non logged in users
export const newsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRequestNews: builder.mutation({
      query: (newsData: FormData) => ({
        url: `/news_request`,
        method: 'POST',
        body: newsData,
      }),
    }),
  }),
})

export const { useGetRequestNewsMutation } = newsSlice
